import type { AgentConfigurationVersion } from '../../queries/agent-configuration-versions';

export interface RunAgentConfig {
  agentId: string;
  configurationVersion: AgentConfigurationVersion;
  teamId?: string;
  shouldNavigateToExecutions?: boolean;
  onExecutionCreated?: (executionId: string) => void;
}

export interface RunAgentFormData {
  agentInput: Record<string, unknown>;
}

export const validateRunAgentConfig = (config: RunAgentConfig): boolean => {
  return !!(
    config.agentId &&
    config.configurationVersion &&
    config.configurationVersion.agentConfigurationVersionId
  );
};

export const getExecutionConfigSummary = (
  config: AgentConfigurationVersion,
) => {
  return {
    maxActions: config.executionConfig.max_actions,
    planningInterval: config.executionConfig.planning_interval,
    timeoutMinutes: config.executionConfig.timeout_minutes,
    toolsCount: config.toolConfig.length,
  };
};

export const formatInputSchema = (
  inputSchema: Record<string, unknown>,
): string => {
  if (!inputSchema || Object.keys(inputSchema).length === 0) {
    return 'No input schema defined';
  }
  return JSON.stringify(inputSchema, null, 2);
};

export const createExecutionPayload = (
  formData: RunAgentFormData,
  config: AgentConfigurationVersion,
) => {
  return {
    agentConfigurationVersionId: config.agentConfigurationVersionId,
    agentInput: formData.agentInput,
    agentInputSchema: config.inputSchema,
    agentInputSummary: JSON.stringify(formData.agentInput).slice(0, 200),
    maxActions: config.executionConfig.max_actions,
    planningInterval: config.executionConfig.planning_interval,
    agentOutputSchema: config.outputSchema,
  };
};
